import React, { ReactElement } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import AdminLayout from "../components/layout/AdminLayout";
import Dashboard from "../features/dashboard/Dashboard";
import UserDirectory from "../features/user-directory/UserDirectory";
import Subscriptions from "../features/subscriptions/Subscriptions";
import SalesEnquiries from "../features/sales-enquiries/SalesEnquiries";
import SupportTickets from "../features/support-tickets/SupportTickets";
import SystemHealth from "../features/system-health/SystemHealth";
import AdminSettings from "../features/settings/AdminSettings";
import AdminDashboard from "../features/dashboard/AdminDashboard";
import AdminLogin from "../features/auth/Login";
 
 

function DashboardRoutes(): ReactElement {
  return (
    <BrowserRouter>
      <Routes>
        {/* The DashboardLayout wraps all internal routes to provide the Sidebar and Topbar */}
        <Route path="/login" element={<AdminLogin />} />
        <Route element={<AdminLayout />}>
          {/* Matches the "Home" nav item */}
          <Route path="/" element={<AdminDashboard />} />
          <Route path="/users" element={<UserDirectory />} />
          <Route path="/subscriptions" element={<Subscriptions />} />
          <Route path="sales_and_enquiries" element={<SalesEnquiries />} />
          <Route path="/support_tickets" element={<SupportTickets />} />
          <Route path="/system_health" element={<SystemHealth />} />
           <Route path="/profile_settings" element={<AdminSettings/>} />
          {/* You can add /companies, /lists, /analytics here later */}
        </Route>

        {/* Catch-all: redirects any unknown dashboard routes back to home */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default DashboardRoutes;
